import { create } from "zustand"
import { persist } from "zustand/middleware"

interface DashboardStore {
  selectedFacility: string
  setSelectedFacility: (facility: string) => void
}

export const useDashboardStore = create<DashboardStore>()(
  persist(
    set => ({
      selectedFacility: "none",
      setSelectedFacility: facility => set({ selectedFacility: facility }),
    }),
    {
      name: "dashboard",
    }
  )
)
